import script from "./ChatContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContent.vue?vue&type=script&setup=true&lang=js"

import "./ChatContent.vue?vue&type=style&index=0&id=63066aa9&lang=scss&scoped=true"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63066aa9"]])

export default __exports__